<template lang="pug">
    div
      span {{ item.UnparsedAddress }}
      abbr Address: {{ item.UnparsedAddress }}
      abbr MLS Status: {{item.MlsStatus }}
      abbr Listing: {{ item.ListingKey }}
</template>

<script>
export default {
    props: {
        item: { required: true }
    }
}
</script>
